import axios from '@/axiosConnection'
export default {
    namespaced: true,
    state: {
        results: [],
    },
    getters: {
        getResults: state => {
            return state.results
        },
    },
    mutations: {
      setResults(state, results) {
        state.results = results
      },
    },
    actions: {
      setResults: (context, search) => {
        context.commit('setResults', search)
      },
    }
}



// WEBPACK FOOTER //
// ./src/stores/modules/search.js